export type BatchStatus = 'COMPARE' | 'DONE' | 'CANCELLED';

export const STATUS_TAGS: Record<BatchStatus, { label: string; color: string }> = {
  COMPARE: { label: 'Харьцуулах бэлэн', color: 'blue' },
  DONE: { label: 'Дууссан', color: 'green' },
  CANCELLED: { label: 'Цуцлагдсан', color: 'default' },
};

export interface BatchRow {
  id: number;
  created_at: string;
  file_name: string;
  status: BatchStatus;
  total_record: number;
  error_record: number;
  deposit_total: number;
  withdrawal_total: number;
  synced_at: string | null;
  created_by_name: string | null;
}

export interface BatchItem {
  id: number;
  row_number: number;
  student_code: string;
  full_name: string;
  student_name: string | null;
  kind: 'DEPOSIT' | 'WITHDRAWAL' | null;
  type_raw: string;
  amount: number | null;
  amount_raw: string;
  description: string | null;
  before_balance: number | null;
  status: 'OK' | 'ERROR';
  message: string | null;
}

export interface BatchDetail extends Omit<BatchRow, 'created_at' | 'created_by_name'> {
  duplicate_batch_ids: number[];
  items: BatchItem[];
}
